export const initInvitationsRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
        {
          path: "/manage/invitations",
          name: "invitations",
          component: () => import("@/pages/manage/invitations/index.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
        {
          path: "/manage/invitations/:id",
          name: "invitations-id",
          component: () => import("@/pages/manage/invitations/id.vue"),
          meta: {
            requiresAuth: true,
            roles: [config.roles.administrators, config.roles.siteEditors],
          },
        },
      ];
